// extracted by mini-css-extract-plugin
export default {"ctaSection":"ThankYouAddressModal__ctaSection__Ejh1l","ModalTitle":"ThankYouAddressModal__ModalTitle__ZMvJ5"};